'use strict';

var angular = require('angular');

import '../app';
import './SiteSearchController';
import './NewsPageController';
import './NewsOpinionPageController';
import './ResourcesPageController';